import React from "react";


export const UserNotfound = () => {
    return <h4>This email is not associated with an active client of AMPT. Please contact your trainer
        for more information</h4>;
};
